import MerchantStaticInfo from '../models/MerchantStaticInfo';

import {
    GET_STATIC_DATA_SUCCESS,
    GET_STATIC_DATA_ERROR,
    FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS,
    FETCH_UNDERLYING_MERCHANT_STATIC_ERROR,
    FETCH_STATIC_INFO_SUCCESS,
    FETCH_STATIC_INFO_ERROR,
    FETCH_AUDIT_TRAIL_STATIC_SUCCESS,
    FETCH_AUDIT_TRAIL_STATIC_ERROR,
    FETCH_CHARGEBACK_STATIC_DATA_SUCCESS,
    FETCH_CHARGEBACK_STATIC_DATA_ERROR,
} from './staticData.constants';

export const initialState = {
    payValues: {},
    underlyingMerchant: [],
    error: {},
    staticInfo: {},
    staticEvents: {},
    chargebackStaticInfo: {},
};
export const staticDataReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Static Data
        case GET_STATIC_DATA_SUCCESS:
            return {
                ...state,
                payValues: { ...action.payload },
                error: {},
            };
        case GET_STATIC_DATA_ERROR:
            return {
                ...state,
                payValues: {},
                ...action.payload,
            };
        case FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS: {
            return {
                ...state,
                error: {},
                underlyingMerchant: [...action.payload],
            };
        }
        case FETCH_UNDERLYING_MERCHANT_STATIC_ERROR:
            return {
                ...state,
                ...action.payload,
                underlyingMerchant: [],
            };
        case FETCH_STATIC_INFO_SUCCESS:
            const staticData = new MerchantStaticInfo(action.payload);
            console.log(action.payload, 'action.payload');
            return { ...state, staticInfo: { ...staticData, merchantTurnover: action.payload.merchantTurnover } };

        case FETCH_STATIC_INFO_ERROR:
            return { ...state, staticInfo: { ...action.payload } };

        case FETCH_AUDIT_TRAIL_STATIC_SUCCESS:
            return {
                ...state,
                staticEvents: { ...action.payload },
            };
        case FETCH_AUDIT_TRAIL_STATIC_ERROR:
            return { ...state, staticEvents: { ...action.payload } };

        case FETCH_CHARGEBACK_STATIC_DATA_SUCCESS:
            return { ...state, chargebackStaticInfo: { ...action.payload } };

        case FETCH_CHARGEBACK_STATIC_DATA_ERROR:
            return { ...state, chargebackStaticInfo: { ...action.payload } };

        default:
            return state;
    }
};
